module.exports = __webpack_public_path__ + "img/icon-2.ca9790c2.png";